var map = {
	"./2.png": [
		25023,
		5023
	],
	"./4.png": [
		21193,
		1193
	],
	"./lapsha-funchoza.png": [
		8991,
		8991
	],
	"./lapsha-pshenichnaya.png": [
		60644,
		644
	],
	"./lapsha-soba.png": [
		58276,
		8276
	],
	"./lapsha-udon.png": [
		95301,
		5301
	],
	"./osnova.png": [
		98329,
		8329
	],
	"./ris.png": [
		28727,
		8727
	],
	"./soup_base.png": [
		83106,
		3106
	],
	"./soup_meat.png": [
		27752,
		7752
	],
	"./soup_sauce.png": [
		20812,
		812
	],
	"./soup_topping.png": [
		68676,
		8676
	],
	"./test-lapsha-soba.png": [
		72767,
		2767
	],
	"./test-lapshaudon.png": [
		74699,
		4699
	],
	"./vegetables.png": [
		4681,
		4681
	],
	"./wok_add_sauce.png": [
		87572,
		7572
	],
	"./wok_meat.png": [
		51088,
		1088
	],
	"./wok_sauce.png": [
		24052
	],
	"./wok_topping.png": [
		52284,
		2284
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 98121;
module.exports = webpackAsyncContext;